var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcInfluencerLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.16 10.1V5.893l1.853-1.3c.907-.633 1.654-.246 1.654.867v5.08c0 1.113-.747 1.5-1.654.86l-1.853-1.3zM7.667 7.333a1 1 0 110-2 1 1 0 010 2z",
    stroke: "#A39CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14 13.613c-2.107 0-2.807-1.4-2.807-2.806V5.193c0-2.106.7-2.806 2.807-2.806h4.213c2.107 0 2.807.7 2.807 2.806v5.614c0 2.106-.707 2.806-2.807 2.806H4.14z",
    stroke: "#655AEC"
  }))));
}

export default SvgIcInfluencerLive;